import { useContext } from 'react';
import { BreadcrumbContext } from 'src/shared/contexts/BreadcrumbContext';

export function useBreadcrumbs() {
  const context = useContext(BreadcrumbContext);

  if (!context) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbProvider');
  }

  const { register, unregister, breadcrumbs } = context;

  return {
    breadcrumbs,
    setBreadcrumb: register,
    removeBreadcrumb: unregister,
  };
}
